export const SEND_EMAIL_API = '/api/v1/users/me/verification';
